import { Tag } from 'antd';
import { trangThaiKPI } from '../../constants';
const statusMap = {
    [trangThaiKPI.khoiTao]: { color: 'processing', text: 'Khởi tạo' },
    [trangThaiKPI.thuHoi]: { color: 'warning', text: 'Thu hồi' },
    [trangThaiKPI.trinhLanhDaoPhong]: { color: 'purple', text: 'Trình lãnh đạo phòng' },
    [trangThaiKPI.lanhDaoPhongTuChoi]: { color: 'error', text: 'Lãnh đạo phòng từ chối' },
    [trangThaiKPI.trinhLanhDaoPhuTrach]: { color: 'cyan', text: 'Trình lãnh đạo phụ trách' },
    [trangThaiKPI.lanhDaoPhuTrachTuChoi]: { color: 'error', text: 'Lãnh đạo phụ trách từ chối' },
    [trangThaiKPI.trinhLanhDaoDonVi]: { color: 'gold', text: 'Trình lãnh đạo đơn vị' },
    [trangThaiKPI.lanhDaoDonViTuChoi]: { color: 'error', text: 'Lãnh đạo đơn vị từ chối' },
    [trangThaiKPI.pheDuyet]: { color: 'success', text: 'Duyệt' }
};

const TrangThaiTag = ({ value, noText }: { value?: number, noText?: boolean }) => {
    if (value == null) return null;

    const status = statusMap[value];
    if (!status) return <Tag>Không xác định</Tag>;
    if (noText) {
        return <Tag color={status.color} title={status.text} style={{ cursor: 'pointer' }}>1</Tag>;
    }
    return <label><Tag color={status.color}>{status.text}</Tag></label>;
};
export default TrangThaiTag;